import React, {Component} from 'react';
import PropTypes from 'prop-types';


const coveringSpinner = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};


export default class Loading2 extends Component {
    render() {
        const {
            loading_state,
            color,
            className,
            style,
            parent_className,
            parent_style,
            fullscreen,
            debug,
            type: spinnerType,
        } = this.props;

        const isLoading = loading_state && loading_state.is_loading;
        let sstyle = {...coveringSpinner};
        sstyle['display'] = isLoading ? 'flex' : 'none';
        return (
            <div
                className={parent_className}
                style={sstyle}
            >
                {this.props.children}
            </div>
        );
    }
}

Loading2._dashprivate_isLoadingComponent = true;

Loading2.propTypes = {
    /**
     * The ID of this component, used to identify dash components
     * in callbacks. The ID needs to be unique across all of the
     * components in an app.
     */
    id: PropTypes.string,
    /**
     * Array that holds components to render
     */
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    /**
     * Boolean that makes the spinner display full-screen
     */
    fullscreen: PropTypes.bool,
    /**
     * Additional CSS class for the spinner root DOM node
     */
    className: PropTypes.string,
    /**
     *  Additional CSS class for the outermost dcc.Loading parent div DOM node
     */
    parent_className: PropTypes.string,
    /**
     * Additional CSS styling for the spinner root DOM node
     */
    style: PropTypes.object,
    /**
     * Additional CSS styling for the outermost dcc.Loading parent div DOM node
     */
    parent_style: PropTypes.object,
    /**
     * Visible
     */
    visible: PropTypes.bool,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};
